/**
 * 日期转换相关工具
 */
import moment, { Moment } from 'moment';

/** Properties of a Timestamp. */
export interface IPBTimestamp {

  /** Timestamp seconds */
  seconds?: (number | null);

  /** Timestamp nanos */
  nanos?: (number | null);
}

// 秒级时间戳
export type IUnixTimestamp = number;

// 毫秒时间戳
export type ITimestamp = number;

// 区别string，明确表示是时间日期格式
export type IDate = string;

/** Properties of a Timestamp. */
export interface IPBTimestamp {

  /** Timestamp seconds */
  seconds?: (number | null);

  /** Timestamp nanos */
  nanos?: (number | null);
}

/**
 * 时间戳转pb时间戳
 * @param timestamp
 */
export function timestampToPBTime(timestamp: ITimestamp | IUnixTimestamp): IPBTimestamp {
  // 统一转为毫秒时间戳
  const ts: ITimestamp = `${timestamp}`.length > 10 ? timestamp : timestamp * 1000;
  const date: Moment = moment(ts);

  return {
    seconds: date.unix(),
    nanos: date.millisecond() * 1000000,
  };
}

/**
 * JS时间戳转为PB时间戳格式
 */
export function toPBTime(time?: IDate | Moment): IPBTimestamp {
  let date: Moment;
  if (!time) {
    date = moment();
  } else if (typeof time === 'string') {
    date = moment(time);
  } else {
    date = time;
  }
  return {
    seconds: date.unix(),
    nanos: date.millisecond() * 1000000,
  };
}

/**
 * PB时间戳格式转为JS时间戳
 */
export function fromPBTime(timestamp?: IPBTimestamp | null): Moment {
  const seconds = timestamp?.seconds || 0;
  const nanos = timestamp?.nanos || 0;
  return moment((seconds * 1000) + (nanos / 1000000));
};
